const translations = {
    'prompt.houseFoodTarget': 'Ustaw cel zapasu żywności (godziny):',
    'prompt.houseHeatTarget': 'Ustaw cel zapasu opału (godziny):',
    'prompt.blacksmithToolsTarget': 'Ustaw cel narzędzi kuźni (%s):',
    'prompt.blacksmithWeaponsTarget': 'Ustaw cel broni kuźni (%s):',
    'prompt.productionInputCap': 'Ustaw limit wejscia (%s):',
    'prompt.productionOutputCap': 'Ustaw limit wyjscia (%s):',
};

export default translations;
